import * as types from '../constants';

let initialState = {
  user: {},
  isLoading: false,
  vErrors: null,
  success: null,
  confirmation_code: null,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.STORE_LOYALTY_START:
      return {
        ...state,
        isLoading: true,
      };
    case types.STORE_LOYALTY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: payload,
      };
    case types.STORE_LOYALTY_FAILURE:
      return {
        ...state,
        isLoading: false,
        payload,
      };
    case types.SET_V_ERRORS:
      return {
        ...state,
        vErrors: payload,
      };
    case types.UPDATE_MESSAGE:
      return {
        ...state,
        success: payload,
      };
    case types.CONFIRM_PHONE_SUCCESS:
      return {
        ...state,
        confirmation_code: payload,
      };
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload,
      };
    default:
      return state;
  }
};

export default reducer;
